export const RotateLeft = (props: React.SVGProps<SVGSVGElement>) => {
    return (
      <svg
        {...props}
        width="1em"
        height="1em"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          id="Rotate-Left-Dash-4--Streamline-Core.svg"
          clipPath="url(#clip0_61_1027)"
        >
          <g id="rotate-left-dash-4">
            <path
              id="Vector"
              d="M12.5001 1.72156C11.5833 1.72156 10.6754 1.83847 9.79732 2.06592M6.51192 3.53805C5.49037 4.22062 4.5987 5.06894 3.87035 6.04227M1.92879 14.6027C1.57226 12.8104 1.67824 10.9619 2.2297 9.22989M4.87861 20.1214C4.32815 19.5709 3.84181 18.9655 3.42591 18.3166"
              stroke="currentcolor"
              strokeWidth="1.7114"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              id="Vector_2"
              d="M23.2783 5.03797L19.9619 4.20886L19.1328 7.52529"
              stroke="currentcolor"
              strokeWidth="1.7114"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              id="Vector_3"
              d="M4.87866 20.1214C6.38605 21.6287 8.30657 22.6553 10.3974 23.0712C12.4882 23.4871 14.6554 23.2737 16.6249 22.4578C18.5944 21.642 20.2777 20.2605 21.462 18.4881C22.6464 16.7156 23.2785 14.6317 23.2785 12.4999C23.282 9.41229 22.0939 6.44238 19.9621 4.20886"
              stroke="currentcolor"
              strokeWidth="1.7114"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_61_1027">
            <rect width="25" height="25" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  };
  